export var DEFAULT = {};